var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/fonts/Inter/Inter-VariableFont_slnt_wght.woff2": "26cb",
	"./assets/fonts/Poppins/Poppins-Bold.woff2": "0c09",
	"./assets/fonts/Poppins/Poppins-Light.woff2": "048e",
	"./assets/fonts/Poppins/Poppins-Medium.woff2": "2a21",
	"./assets/fonts/Poppins/Poppins-Regular.woff2": "585a",
	"./assets/fonts/Poppins/Poppins-SemiBold.woff2": "1f49",
	"./assets/fonts/style.css": "710a",
	"./assets/icons/font/fonts/icomoon.eot": "8fd9",
	"./assets/icons/font/fonts/icomoon.svg": "3da8",
	"./assets/icons/font/fonts/icomoon.ttf": "a867",
	"./assets/icons/font/fonts/icomoon.woff": "64ee",
	"./assets/icons/font/selection": "272c",
	"./assets/icons/font/selection.json": "272c",
	"./assets/icons/font/style.css": "dafa",
	"./assets/icons/mail-unread.png": "e714",
	"./assets/icons/select-arrow.png": "3cdc",
	"./assets/icons/vue.svg": "0dcb",
	"./assets/images/burrito.webp": "aa86",
	"./assets/images/img-ahorra.webp": "586d",
	"./assets/images/img-antros.webp": "ea07",
	"./assets/images/img-bebidas-bares.webp": "46de",
	"./assets/images/img-business-intelligence.webp": "4393",
	"./assets/images/img-contacto.webp": "0881",
	"./assets/images/img-form-menu.webp": "ef22",
	"./assets/images/img-form-productos.webp": "dc59",
	"./assets/images/img-form-soluciones.webp": "1ded",
	"./assets/images/img-franquicias-restaurantes-multisucursal.webp": "be20",
	"./assets/images/img-funcionalidades-medida.webp": "4ebd",
	"./assets/images/img-hoteles.webp": "3872",
	"./assets/images/img-main.webp": "15a5",
	"./assets/images/img-multisucursal.webp": "fa13",
	"./assets/images/img-navegacion-app.webp": "90e9",
	"./assets/images/img-ordena.webp": "9a65",
	"./assets/images/img-panel-multimarca.webp": "e7d5",
	"./assets/images/img-personaliza.webp": "3552",
	"./assets/images/img-publicidad-negocio.webp": "524f",
	"./assets/images/img-servidor.webp": "76a2",
	"./assets/images/img-soporte-tecnico.webp": "a09d",
	"./assets/images/img-subir-menu.webp": "2100",
	"./assets/images/img-testimonios.webp": "4739",
	"./assets/images/mezcantina-logo.webp": "cfba",
	"./assets/images/mobile/img-antros.webp": "186b",
	"./assets/images/mobile/img-form-menu.webp": "b379",
	"./assets/images/mobile/img-form-productos.webp": "f262",
	"./assets/images/mobile/img-form-soluciones.webp": "d13f",
	"./assets/images/mobile/img-franquicias-restaurantes-multisucursal.webp": "f6c6",
	"./assets/images/mobile/img-hoteles.webp": "f47f",
	"./assets/images/mobile/img-main.webp": "18da",
	"./assets/images/mobile/img-multisucursal.webp": "018f",
	"./assets/images/mobile/img-panel-multimarca.webp": "4a51",
	"./assets/images/mobile/img-publicidad-negocio.webp": "4f04",
	"./assets/images/mobile/img-subir-menu.webp": "3d4d",
	"./assets/images/png/burrito.png": "4687",
	"./assets/images/png/img-ahorra.png": "a3f5",
	"./assets/images/png/img-antros.png": "59d4",
	"./assets/images/png/img-bebidas-bares.png": "effa",
	"./assets/images/png/img-bisiness-intelligence.png": "a272",
	"./assets/images/png/img-contacto.png": "c74d",
	"./assets/images/png/img-form-menu.png": "f1aa",
	"./assets/images/png/img-form-productos.png": "6621",
	"./assets/images/png/img-form-soluciones.png": "cdea",
	"./assets/images/png/img-franquicias-restaurantes-multisucursal.png": "219e",
	"./assets/images/png/img-funcionalidades-medida.png": "51cd",
	"./assets/images/png/img-header.png": "84f4",
	"./assets/images/png/img-hotels.png": "5db1",
	"./assets/images/png/img-multisucursal.png": "1e0b",
	"./assets/images/png/img-navegacion-app.png": "ab27",
	"./assets/images/png/img-ordena.png": "2993",
	"./assets/images/png/img-panel-multimarca.png": "d25e",
	"./assets/images/png/img-personaliza.png": "1bc4",
	"./assets/images/png/img-publicidad-negocio.png": "6f16",
	"./assets/images/png/img-servidor.png": "ba31",
	"./assets/images/png/img-soporte-tecnico.png": "4419",
	"./assets/images/png/img-subir-menu.png": "8358",
	"./assets/images/png/img-testimonios.png": "063f",
	"./assets/images/png/slide-1.png": "9211",
	"./assets/images/png/slide-2.png": "afc0",
	"./assets/images/png/slide-3.png": "d4c3",
	"./assets/images/png/slide-4.png": "ad30",
	"./assets/images/png/slide-5.png": "ba43",
	"./assets/images/slide-1.webp": "aeee",
	"./assets/images/slide-2.webp": "5913",
	"./assets/images/slide-3.webp": "5925",
	"./assets/images/slide-4.webp": "6416",
	"./assets/images/slide-5.webp": "6904",
	"./assets/logo.webp": "4841",
	"./assets/mindfood-light.png": "3f0d",
	"./components/Benefits": "3fd7",
	"./components/Benefits.vue": "3fd7",
	"./components/Contact": "371a",
	"./components/Contact.vue": "371a",
	"./components/CustomSolution": "d396",
	"./components/CustomSolution.vue": "d396",
	"./components/FAQ": "d2c1",
	"./components/FAQ.vue": "d2c1",
	"./components/Features": "3f50",
	"./components/Features.vue": "3f50",
	"./components/Hero": "2514",
	"./components/Hero.vue": "2514",
	"./components/HowToUse": "99bd",
	"./components/HowToUse.vue": "99bd",
	"./components/Pricing": "8aff",
	"./components/Pricing.vue": "8aff",
	"./components/Services": "76d2",
	"./components/Services.vue": "76d2",
	"./components/Testimonials": "7af8",
	"./components/Testimonials.vue": "7af8",
	"./components/TrialPeriodCta": "83d4",
	"./components/TrialPeriodCta.vue": "83d4",
	"./components/common/Accordion": "c976",
	"./components/common/Accordion.vue": "c976",
	"./components/common/BenefitCard": "3a2a",
	"./components/common/BenefitCard.vue": "3a2a",
	"./components/common/Button": "90cd",
	"./components/common/Button.vue": "90cd",
	"./components/common/Carousel": "a1b0",
	"./components/common/Carousel.vue": "a1b0",
	"./components/common/CarouselTestimonials": "4c46",
	"./components/common/CarouselTestimonials.vue": "4c46",
	"./components/common/Checklist": "eced",
	"./components/common/Checklist.vue": "eced",
	"./components/common/Footer": "cdaa",
	"./components/common/Footer.vue": "cdaa",
	"./components/common/HamburgerButton": "ec25",
	"./components/common/HamburgerButton.vue": "ec25",
	"./components/common/Input": "eb11",
	"./components/common/Input.vue": "eb11",
	"./components/common/Logo": "16d4",
	"./components/common/Logo.vue": "16d4",
	"./components/common/Nav": "36e1",
	"./components/common/Nav.vue": "36e1",
	"./components/common/Navbar": "7106",
	"./components/common/Navbar.vue": "7106",
	"./components/common/PlanCard": "3b9b",
	"./components/common/PlanCard.vue": "3b9b",
	"./components/common/SolutionCard": "573a",
	"./components/common/SolutionCard.vue": "573a",
	"./components/common/Spinner": "1462",
	"./components/common/Spinner.vue": "1462",
	"./components/common/Toggle": "670a",
	"./components/common/Toggle.vue": "670a",
	"./components/form/FormInfo": "fa75",
	"./components/form/FormInfo.vue": "fa75",
	"./components/form/FormInputs": "2d13",
	"./components/form/FormInputs.vue": "2d13",
	"./components/form/FormSuccess": "e96c",
	"./components/form/FormSuccess.vue": "e96c",
	"./config": "db49",
	"./config.js": "db49",
	"./main": "56d7",
	"./main.js": "56d7",
	"./registerServiceWorker": "ddb8",
	"./registerServiceWorker.js": "ddb8",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./scss/_bootstrap.scss": "ce5e",
	"./scss/_general.scss": "608c",
	"./scss/_mixins.scss": "60c1",
	"./scss/_variables.scss": "7ada",
	"./scss/main.scss": "b107",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./store/inputs": "5204",
	"./store/inputs.js": "5204",
	"./store/modules/form.module": "10b2",
	"./store/modules/form.module.js": "10b2",
	"./store/modules/menu.module": "148f",
	"./store/modules/menu.module.js": "148f",
	"./utils": "ed08",
	"./utils/": "ed08",
	"./utils/index": "ed08",
	"./utils/index.js": "ed08",
	"./views/FormCustomSolution": "0d32",
	"./views/FormCustomSolution.vue": "0d32",
	"./views/FormMultimarca": "24f0",
	"./views/FormMultimarca.vue": "24f0",
	"./views/FormServices": "16b7",
	"./views/FormServices.vue": "16b7",
	"./views/FormSignUp": "acbc",
	"./views/FormSignUp.vue": "acbc",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/NotFound": "9703",
	"./views/NotFound.vue": "9703"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";